<div>
  <div class="tooltip-head">
    <div class="flex gap-spacing-xs align-items-center">
      <span
        [ngClass]="{
          'feedback-info-fg-bg': stop()?.statusType == 'Arrived',
          'text-link-bg': stop()?.statusType == 'EnRoute',
          'icon-success-subtle-bg': stop()?.statusType == 'Visited'
        }"
        class="dot"></span>
      <span class="title"> {{ isClient && stop()?.statusType?.toLowerCase() === "enroute" ? "In Progress" : isClient && stop()?.statusType?.toLowerCase() === "visited" ? "Completed" : stop()?.statusType }}</span>
    </div>
  </div>

  <div class="tooltip-body">
    <div class="item">
      <span>Scheduled Arrival Time</span>
      <span class="time">{{ stop()?.scheduledArrivalTime }}</span>
    </div>
    <div class="item">
      <span>Estimated Arrival Time</span>
      <span class="time">
        {{ stop()?.estimatedArrivalTime }}

        @if (stop()?.statusDescription) {
          <span class="flex gap-spacing-default align-items-center">
            <i
              [ngClass]="{
                'feedback-danger-fg-color': stop()?.arrivalTimeStatus == 'late',
                'feedback-success-fg-color': stop()?.arrivalTimeStatus == 'early',
                'feedback-warning-fg-color': stop()?.arrivalTimeStatus == 'alert',
                'text-link-color': stop()?.arrivalTimeStatus == 'onTime'
              }"
              class="icon-hourglass-low-solid"></i>
            {{ stop()?.statusDescription }}
          </span>
        }
      </span>
    </div>
    <div class="item">
      <span>Actual Arrival Time</span>
      <span class="time">{{ stop()?.actualArrivalTime ?? 'Have not arrived yet.' }}</span>
    </div>
  </div>
</div>
